import request from './request'

//获取登录二维码
export function getqrcode(data) {
  return request({
    url: 'getqrcode',
    method: 'post',
    data
  })
}

//扫码验证
export function checklogin(data) {
  return request({
    url: 'checklogin',
    method: 'post',
    data
  })
}

//获取验证码
export function sendcode(data) {
  return request({
    url: 'sendcode',
    method: 'post',
    data
  })
}


//验证码登录
export function codelogin(data) {
  return request({
    url: 'codelogin',
    method: 'post',
    data
  })
}

//绑定完善信息
export function saveinfo(data) {
  return request({
    url: 'saveinfo',
    method: 'post',
    data
  })
}

//账号密码登录
export function passlogin(data) {
  return request({
    url: 'passlogin',
    method: 'post',
    data
  })
}


//退出登录
export function loginout(data) {
  return request({
    url: 'loginout',
    method: 'post',
    data
  })
}

//验证验证码正确
export function checkcode(data) {
  return request({
    url: 'checkcode',
    method: 'post',
    data
  })
}

//换绑手机号
export function changephone(data) {
  return request({
    url: 'changephone',
    method: 'post',
    data
  })
}

//换绑手机号
export function changepass(data) {
  return request({
    url: 'changepass',
    method: 'post',
    data
  })
}